/**
 * Headless: flushes any unsynced bug reports to the collector on app start and
 * whenever connectivity returns, so a report logged offline (PC off / no signal)
 * lands as soon as it can, without the user doing anything. The feedback panel
 * opening and the "Resend all" button are the other retry triggers.
 *
 * BOLT-ON: part of feedback/; remove the <FeedbackSyncRunner/> from Shell to strip.
 */
import { useEffect, useRef } from 'react';
import { useFeedbackStore } from './feedbackStore';
import { useNetworkStore } from '@/store/network';

export function FeedbackSyncRunner() {
  const online = useNetworkStore((s) => s.online);
  const wasOnline = useRef(online);

  // On mount (app start): try to drain the queue.
  useEffect(() => {
    void useFeedbackStore.getState().flush();
  }, []);

  // On the offline -> online transition: retry.
  useEffect(() => {
    if (online && !wasOnline.current) void useFeedbackStore.getState().flush();
    wasOnline.current = online;
  }, [online]);

  return null;
}
